import Wrapper from "../assets/wrappers/MainArea";
import main from "../assets/images/mainarea.png";
import { MdCheckCircle } from "react-icons/md";
const MainArea = () => {
  return (
    <Wrapper name="mainareas">
      <div className="container">
        <div className="left" data-aos="zoom-in">
          <img className="image" src={main} alt="Physical therapy expertise areas pattern showcasing orthopedics, sports medicine, neurology, and geriatrics specializations" />
        </div>
        <div className="right">
          <h3 data-aos="fade-left">
            Areas of <span className="colorfull"> Expertise</span>
          </h3>
          <ul data-aos="fade-left">
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Orthopedics
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Sports Medicine
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Dry Needling
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Cupping Therapy
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Pressotherapy
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Electrotherapy
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Manual Therapy
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Post-Operative Care
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Spine Rehabilitation
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Chronic Pain Management
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Balance & Fall Prevention
            </li>
            <li>
              {" "}
              <MdCheckCircle className="check-icon" /> Home Therapy
            </li>
          </ul>
        </div>
      </div>
    </Wrapper>
  );
};

export default MainArea;
